import PosthogService from '~/services/posthog/PosthogService';
import { type TShiftRequestFlowStep } from './flowSteps';

/** The ticket's `modal_closed` is omitted: this wizard is routed pages, not a modal. */
export type TShiftRequestExitTrigger = 'navigation' | 'cancel_clicked' | 'page_unload';

export interface IShiftRequestAbandonedPayload {
  lastStepReached: TShiftRequestFlowStep;
  lastStepIndex: number;
  exitTrigger: TShiftRequestExitTrigger;
  professionalTypeSelected?: string;
  datesSelected?: boolean;
  timeInFlowSeconds?: number;
}

/**
 * Fires when an office leaves the shift request wizard without posting (GOTU-5396).
 * `funnelEntryId` is attached automatically — see `funnelRegistry`.
 * Event: dental_portal:shift_request:abandoned
 */
export function fireShiftRequestAbandoned(payload: IShiftRequestAbandonedPayload): void {
  PosthogService.getInstance().track('dental_portal:shift_request:abandoned', {
    last_step_reached: payload.lastStepReached,
    last_step_index: payload.lastStepIndex,
    exit_trigger: payload.exitTrigger,
    professional_type_selected: payload.professionalTypeSelected,
    dates_selected: payload.datesSelected,
    time_in_flow_seconds: payload.timeInFlowSeconds,
    'Design Date': 202603,
  });
}
